module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/fail_e0b05d.png";